import { PureComponent } from 'react'
import { connect } from 'react-redux'
import { func } from 'prop-types'
import { streetsSmartApiLoaded } from '../../../store/Actions/CycloramaActions'
import { loadScripts } from './utils'

class CycloDependencies extends PureComponent {
  componentDidMount = () => {
    this.checkScripts()
  }

  checkScripts = async () => {
    let scriptsLoaded = await loadScripts()
    if (scriptsLoaded) {
      this.props.streetsSmartApiLoaded(true)
    } else {
      console.log('Cyclomedia could not be loaded')
    }
  }

  componentWillUnmount = () => {
    this.props.streetsSmartApiLoaded(false)
  }

  render() {
    return this.props.children
  }
}

CycloDependencies.propTypes = {
  streetsSmartApiLoaded: func.isRequired,
}

const mapDispatchToProps = dispatch => ({
  streetsSmartApiLoaded: value => dispatch(streetsSmartApiLoaded(value)),
})

export default connect(null, mapDispatchToProps)(CycloDependencies)



// WEBPACK FOOTER //
// ./src/components/Cyclomedia/CycloDependencies/index.jsx